module.exports = __webpack_public_path__ + "static/media/unternehmen-online_ausschnitt.0d66ec15.jpg";